/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Components
import PassportShippingTruck from '../../assets/svg/PassportShippingTruck';
import BuildingSolid from '../../assets/svg/BuildingSolid';
import HomeSolid from '../../assets/svg/HomeSolid';

import { DeliveryHoursStyle } from '../../style/DeliveryHoursStyle';

const styles = ({ typography, palette }) => DeliveryHoursStyle(typography, palette);

const DeliveryHours = ({ classes, shadowEffect }) => (
    <div className={`${shadowEffect ? `${classes.DeliveryHoursStyle} shadowStyle margin-bottom-2x` : classes.DeliveryHoursStyle} margin-bottom-2x`}>
        <div className="deliveryLabel">
            <PassportShippingTruck />
            <div>Delivery Hours</div>
        </div>
        <div className="deliveryRes">
            <HomeSolid />
            <div>
                <div>Residential:</div>
                <div className="bold">9AM to 8PM</div>
            </div>
        </div>
        <div className="deliveryBus">
            <BuildingSolid />
            <div>
                <div>Businesses:</div>
                <div className="bold">9AM to 6PM</div>
            </div>
        </div>
    </div>
);

DeliveryHours.defaultProps = {
    shadowEffect: false,
};

DeliveryHours.propTypes = {
    classes: PropTypes.object.isRequired,
    shadowEffect: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(DeliveryHours);
